import React from 'react';
import './Details.css'
import Header from '../components/Layout/header';
import Footer from '../components/Layout/Footer';
import mapleHouse from '../Assets/Imgs/maplehouse.jpg';
import locationIcon from '../Assets/Icons/location.svg';
import MainBtn from '../components/Common/Btn';
import ContactForm from '../components/Layout/Contact';
import RoomRow from '../components/Common/RoomRow';
import SectionTitle from '../components/Common/SectionTitle';
import LayoutImg from '../Assets/Imgs/LayoutImg.png'
import Floorplan from '../Assets/Imgs/Floorplan.png'
import ExtraImg from '../components/Common/DetailsExtraImg';
import extraDetails1 from '../Assets/Imgs/extraDetails1.jpg';
import extraDetails2 from '../Assets/Imgs/extraDetails2.jpg';
import extraDetails3 from '../Assets/Imgs/extraDetails3.jpg';

const Details = () => {
    return ( 
        <>
        <Header />
        <main>
            <div className="gridBg"></div>
            <div className="detailsSec1">
                <img className='detailsImg' src={mapleHouse} alt="House" />
                <div className="houseDetails">
                    <div className="detailsTitle">
                        <h3>Maple House</h3>
                        <div className="detailsLocation">
                            <img src={locationIcon} alt="Pin icon for location" />
                            <h5>Nasr City, Cairo</h5>
                        </div>
                    </div>
                    <div className="details-32">
                        <h5>Elegant House Villas with spacious layouts, gardens, and premium amenities for luxurious living.</h5>
                        <div className="detailsPrice">
                            <h5>Price</h5>
                            <span>24,000,000 EGP</span>
                        </div>
                        <MainBtn btnText="REQUEST A CONSULTATION" btnStyle="detailsBtn" />
                    </div>
                    <div className="detailsImgSlider">
                        <ExtraImg extraImgStyle="detExtraImg" extraImg={extraDetails1} />
                        <ExtraImg extraImgStyle="detExtraImg detExtraImgInactive" extraImg={extraDetails2} /> 
                        <ExtraImg extraImgStyle="detExtraImg detExtraImgInactive" extraImg={extraDetails3} /> 
                    </div>
                </div>
            </div>

            <section className='Layout'>
                <SectionTitle SectionTitle="House" HighlightedWord="Layout" />

                <div className='LayoutContent'>
                    <div className='Rooms'>
                        <div className='RoomTable'>
                             <RoomRow RoomName="Property Rooms:" RoomValue="2" />
                             <RoomRow RoomName="Property Bathrooms:" RoomValue="1" />
                             <RoomRow RoomName="Kitchen:" RoomValue="Two full kitchens with appliances" />
                             <RoomRow RoomName="Heating/Cooling:" RoomValue="Ductless mini-split systems"/>
                             <RoomRow RoomName="Flooring:" RoomValue="Engineered wood"/>
                        </div>
                        <img className='LayoutImg' src={LayoutImg} alt="" />
                    </div>
                    <img className='Floorplan' src={Floorplan} alt="" />
                    
                </div>
            </section>

            <ContactForm />
        </main>
        <Footer />
        </>
     );
}
 
export default Details;